import { Box } from "@mui/material";
import { styled } from "@mui/material/styles";

export const ChartWrapper = styled(Box)(({ theme }) => ({
  width: "100%",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  mt: theme.spacing(1),
  fontFamily: theme.typography.fontFamily,

  "& svg": {
    overflow: "visible",
  },
}));
